const LOGIN_URL = 'sessions/login'
const BANNER_LIST = '/banners'
const BANNER_LIST_USER = '/user/banners'
const TESTIMONIALS = '/testimonials'
const TESTIMONIALS_USER = '/user/testimonials'
const CUSTOMER_CREATE = 'approver'
const CUSTOMER_LIST = 'customer_types'
const APPROVER_LIST = 'approver'
const APPROVER_DELETE = 'approver'
const ADMIN_INSTITUTIONS = 'admin'
const CUSTOMER_MODE = 'admin_types'
const OUR_TEAM = '/our-team'
const OUR_TEAM_USER = '/user/our-team'
const ABOUT_KIED = '/about'
const ABOUT_KIED_USER = '/user/about'
const CREATE_GRIEVANCE = '/user/grievances'
const VIDEOS = '/video'
const OUR_MEMBERS = '/member'
const PHOTOS_LIST = '/photos'
const RTI = '/rti'
const RTI_USER = '/user/rti'
const ACTS_RULES = '/rules'
const ACTS_RULES_USER = '/user/rules'
const VERIFY_EMAIL = '/verify-email'
const PARTNER_LIST = '/our-partners'
const PHOTO_LIST = '/photos'
const DASHBOARD_USER = '/user/dashboard'
const INCUBATION_LISTING = '/user/incubation-applications'
const INCUBATION_DETAIL = '/user/incubation-applications'
const RESET_PASSWORD = '/reset-password-confirm'

const APPROVER_UPDATE = 'approver'
const APPROVER_VIEW = 'approver'
const APPROVER_CLASS_VIEW = 'approver/list_customer_types'
const APPROVER_ASSIGN = 'approver/assign_templates'
const APPROVER_BULK_ASSIGN = 'approver/bulk_assign'
const APPROVER_DETAILS = 'admin/list_available_customer_types'
const SUPER_ADMIN_DASHBOARD = 'dashboard/super_admin'
const ADMIN_DASHBOARD = 'dashboard/admin'
const REQUEST_LIST = 'id_requests'
const TEMPLATE_ASSIGN = 'customer_templates'
const APPROVER_TEMPLATE_ASSIGN = 'approver/assign_templates'
const UPLOADED_PHOTO_LISTING = 'id_requests/list_requests_by_customer'
const CUSTOMER_DETAILS = 'id_requests/show_by_customer'
const CUSTOMER_TYPE = 'admin/list_customer_types'
const PROFILE = 'users/profile'
const TEMPLATE_LISTING = 'customer_templates/list_templates'
const ADMIN_PRINT = 'admin/print'
const ADMIN_FILE_UPLOAD = 'admin/get_customer_excels'
const FILE_UPLOAD_CREATE = 'admin/upload_customer_excels'
const FILE_UPLOAD = 'id_requests/upload_excel'
const UPDATE_EXCEL_STATUS = 'admin/update_excel_status'
const REPORT_GENERATION = 'id_requests/report'
const FAQ_CREATE = 'users/create_faq'
const FAQ_UPDATE = 'users/update_faq'
const FAQ_LIST = 'users/faqs'
const FAQ_DESTROY = 'users/destroy_faq'
const INDUSTRY_ACADEMIA_COLLABRARTION = 'industry-academia-applications'
const DISTRICT_LIST = 'district/list'
const CAREER_LIST = 'career'
const MATERIAL_LIST = 'material'
const CONTACT_US = '/contact'
const TRAININGCALENDAR = '/program'
const TERMSANDCONDITION = '/terms'
// edc
const LOGIN = '/login'
const REGISTERAION = '/register'
const SCHEMES_LIST = '/scheme'
const EVENT_LIST = '/event'
const ANNUL_REPORTS = '/annual-reports'
const ANNUL_REPORTS_USER = '/user/annual-reports'
const ADVERTISEMENT_LIST = '/advertisements'
const INCUBATION_CREATE = '/user/incubation-applications'
const INCUBATION_LIST = '/user/incubation-applications'
const FACILITATION_CREATE = '/user/facilitation'
const FACILITATION_LIST = '/user/facilitation/mine'
const INTERNSHIP_LIST_USER = '/user/internships'
const INTERNSHIP_LIST_COMMON = '/internships'
const CREATE_INTERNSHIP = '/user/internship-applications'
const FACILITATION_DETAIL = '/user/facilitation'
const LEARNING_FORM = '/programs'
const PROGRAM_DETAILS = '/program'
const BOOKINGS = '/bookings'
const PROGRAM_BOOKINGS = 'program-bookings'
const EVENTBOOKINGS = '/eventbookings'
const FETCH_INITIAL_PROFILE = '/loggeduser'
const TENDERS = '/tender'
const FORGOT_PASSWORD = '/reset-url'
const PUBLICATION_USER = '/user/publications'
const PUBLICATION_COMMON = '/publications'
const CHANGE_ROLE = '/user/change-role'
const PROFILE_UPDATE = '/user-profile'
const DASHBOARD_CERTIFICATE = '/user/certificates'
const apiUrl: { [key: string]: string } = {
  LOGIN_URL,
  CUSTOMER_CREATE,
  CUSTOMER_LIST,
  APPROVER_LIST,
  APPROVER_DELETE,
  ADMIN_INSTITUTIONS,
  CUSTOMER_MODE,
  REQUEST_LIST,
  TEMPLATE_ASSIGN,
  APPROVER_UPDATE,
  APPROVER_VIEW,
  APPROVER_CLASS_VIEW,
  APPROVER_ASSIGN,
  APPROVER_BULK_ASSIGN,
  APPROVER_DETAILS,
  APPROVER_TEMPLATE_ASSIGN,
  SUPER_ADMIN_DASHBOARD,
  ADMIN_DASHBOARD,
  UPLOADED_PHOTO_LISTING,
  CUSTOMER_DETAILS,
  CUSTOMER_TYPE,
  PROFILE,
  TEMPLATE_LISTING,
  ADMIN_PRINT,
  ADMIN_FILE_UPLOAD,
  FILE_UPLOAD_CREATE,
  FILE_UPLOAD,
  UPDATE_EXCEL_STATUS,
  REPORT_GENERATION,
  FAQ_CREATE,
  FAQ_UPDATE,
  FAQ_LIST,
  FAQ_DESTROY,
  LOGIN,
  BANNER_LIST,
  BANNER_LIST_USER,
  TESTIMONIALS,
  TESTIMONIALS_USER,
  OUR_MEMBERS,
  ABOUT_KIED,
  ABOUT_KIED_USER,
  CREATE_GRIEVANCE,
  REGISTERAION,
  VIDEOS,
  INDUSTRY_ACADEMIA_COLLABRARTION,
  OUR_TEAM,
  OUR_TEAM_USER,
  DISTRICT_LIST,
  CAREER_LIST,
  MATERIAL_LIST,
  CONTACT_US,
  SCHEMES_LIST,
  RTI,
  RTI_USER,
  EVENT_LIST,
  TRAININGCALENDAR,
  ACTS_RULES,
  ACTS_RULES_USER,
  PHOTOS_LIST,
  ANNUL_REPORTS,
  ANNUL_REPORTS_USER,
  VERIFY_EMAIL,
  ADVERTISEMENT_LIST,
  INCUBATION_CREATE,
  INCUBATION_LIST,
  FACILITATION_CREATE,
  FACILITATION_LIST,
  PARTNER_LIST,
  PHOTO_LIST,
  INTERNSHIP_LIST_USER,
  INTERNSHIP_LIST_COMMON,
  CREATE_INTERNSHIP,
  DASHBOARD_USER,
  INCUBATION_LISTING,
  INCUBATION_DETAIL,
  FACILITATION_DETAIL,
  LEARNING_FORM,
  PROGRAM_DETAILS,
  BOOKINGS,
  PROGRAM_BOOKINGS,
  EVENTBOOKINGS,
  FETCH_INITIAL_PROFILE,
  TENDERS,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  PUBLICATION_USER,
  PUBLICATION_COMMON,
  TERMSANDCONDITION,
  CHANGE_ROLE,
  PROFILE_UPDATE,
  DASHBOARD_CERTIFICATE,
}

export default apiUrl

//
